module.exports = __webpack_public_path__ + "media/images/icon_back-0fa8fc10ad6cc90f08093fd65eba3309.svg";